import { render, staticRenderFns } from "./HarmongramScreen.vue?vue&type=template&id=4656cf7e"
import script from "./HarmongramScreen.vue?vue&type=script&lang=js"
export * from "./HarmongramScreen.vue?vue&type=script&lang=js"
import style0 from "./HarmongramScreen.vue?vue&type=style&index=0&id=4656cf7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports